import { NgModule } from "@angular/core";
import { EllipsisPipe } from "./ellipsis.pipe";
import { SearchPipe } from "./search.pipe";
import { CamelToWordsPipe } from "./cameltowords.pipe";

const component = [SearchPipe, EllipsisPipe, CamelToWordsPipe];

@NgModule({
  declarations: [component],
  imports: [],
  exports: [component],
})
export class PipesModule {}
